module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon2.7138e1d6.svg";